function getIconPalette(checked) {
  if (checked) return { palette: 'primary', tone: 1 };
  return { palette: 'primary', tone: 0 };
}

export { getIconPalette };
